import { Link } from 'gatsby'
import React from 'react'

import { buildImageObj, cn, getUrlForType } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'
import BlockText from './block-text'
import styles from './preview.module.css'
import { responsiveTitle3 } from './typography.module.css'

function Preview (props) {
  const pageLink = getUrlForType(props.publishedAt, props.slug.current, props.type)
  return (
    <Link className={styles.root} to={pageLink}>
      <div className={styles.leadMediaThumb}>
        {props.mainImage && props.mainImage.asset && (
          <img
            src={imageUrlFor(buildImageObj(props.mainImage))
              .width(600)
              .height(Math.floor((9 / 16) * 600))
              .url()}
            loading={props.priorityImage ? 'eager' : 'lazy'}
            fetchpriority={props.priorityImage ? 'high' : 'low'}
            alt={props.mainImage.alt || ''}
          />
        )}
      </div>
      <h3 className={cn(responsiveTitle3, styles.title)}>{props.title}</h3>
      {props._rawExcerpt && (
        <div className={styles.excerpt}>
          <BlockText blocks={props._rawExcerpt} />
        </div>
      )}
    </Link>
  )
}

export default Preview
